import TripEditForm from "../../Components/Trips/TripEditForm";

const TripsEdit = () => {
  return (
    <div>
      <TripEditForm />
    </div>
  );
};

export default TripsEdit;
